"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Slider = _interopRequireDefault(require("@material-ui/core/Slider"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _ProductDetailContext = _interopRequireDefault(require("../../../../ProductDetail/context/ProductDetailContext"));
var _ProductSelectionContext = _interopRequireDefault(require("../../../../ProductDetail/context/ProductSelectionContext"));
var _ShopContext = _interopRequireDefault(require("../../../../context/ShopContext"));
var _formatPrice = _interopRequireDefault(require("../../../../utils/formatPrice"));
var _PriceSlider = _interopRequireDefault(require("./PriceSlider.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PriceSlider = () => {
  const {
    shopData
  } = (0, _react.useContext)(_ShopContext.default);
  const {
    currency,
    locale = "de-DE"
  } = shopData || {};
  const {
    isoCode
  } = currency || {};
  const {
    productDetailData
  } = (0, _react.useContext)(_ProductDetailContext.default);
  const {
    customPrice: price = {}
  } = productDetailData || {};
  const {
    from = 0,
    to = 100,
    step = 10
  } = price;
  const {
    productSelection = {},
    setProductSelection
  } = (0, _react.useContext)(_ProductSelectionContext.default);
  const {
    customPrice = 0
  } = productSelection;
  const css = (0, _PriceSlider.default)();
  (0, _react.useEffect)(() => {
    if (from > 0) {
      setProductSelection(prevProductSelection => ({
        ...prevProductSelection,
        customPrice: from
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [from]);
  const handleChange = (event, newValue) => {
    setProductSelection(prevProductSelection => ({
      ...prevProductSelection,
      customPrice: newValue
    }));
  };
  const value = (0, _react.useMemo)(() => {
    return customPrice > from ? customPrice : from;
  }, [customPrice, from]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.priceSlider, "mco-shop-product-detail-voucher-selection-price-slider")
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.label, "mco-shop-product-detail-voucher-selection-price-slider__label")
  }, "Gutscheinwert"), /*#__PURE__*/_react.default.createElement(_Slider.default, {
    classes: {
      root: (0, _clsx.default)(css.slider, "mco-shop-product-detail-voucher-selection-price-slider__slider")
    },
    min: from,
    max: to,
    step: step,
    track: false,
    value: value,
    onChange: handleChange
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.values, "mco-shop-product-detail-voucher-selection-price-slider__values")
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.min, "mco-shop-product-detail-voucher-selection-price-slider__min"),
    variant: "body2"
  }, (0, _formatPrice.default)(from, isoCode, locale)), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.value, "mco-shop-product-detail-voucher-selection-price-slider__value")
  }, (0, _formatPrice.default)(value, isoCode, locale)), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.max, "mco-shop-product-detail-voucher-selection-price-slider__max"),
    variant: "body2"
  }, (0, _formatPrice.default)(to, isoCode, locale))));
};
var _default = exports.default = PriceSlider;